<div class="SCORE-certifcate-frame "[ngClass]="{ 'd-none':onloaddownload}"  #scoreCertificatetemplate>
    <div class="SCORE-certifcate-box">
        <div class="SCORE-certifcate-cntbox">
            <div class="SCORE-certifcate-hdr">
                <h2 class="SCORE-certifcate">CERTIFICATE</h2>
                <h3 class="SCORE-merit-title">OF PARTICIPATION</h3>
                <!-- <img class="SCORE-logo" src="assets/img/scorenewstem.png" alt="score logo" /> -->
                <img class="SCORE-logo big-logo" src="assets/img/scorelogo.png" alt="score logo" />
            </div>
            <div class="SCORE-certifcate-body">
                <h4 class="SCORE-certifcate-proud-txt">PROUDLY PRESENTED TO</h4>
                <div class="SCORE-certifcate-stdnt-name">{{user_details?.firstName +' ' +user_details?.lastName}}</div>
                <div class="SCORE-certifcate-smtitle">for successful participation in SCORE – India’s Largest Talent
                    Hunt Exam.</div>
                <div class="SCORE-certifcate-smtitle">Congratulations and good luck for your future endeavours.</div>
            </div>
            <div class="SCORE-certifcate-footr">
                <div class="SCORE-certifcate-input-box">
                    <div class="SCORE-certifcate-input">{{dateofexam}}</div>
                    <div class="SCORE-certifcate-input-label">DATE</div>
                </div>
                <!-- <img class="SCORE-certifcate-ftr-logo" src="assets/img/scorenewlogo.png" /> -->
                <img class="SCORE-certifcate-ftr-logo ftr-new-logo" src="assets/img/certificate-learn-logo.png" />
                <div class="SCORE-certifcate-input-box">
                    <div class="SCORE-certifcate-input">   
                        <img class="SCORE-certifcate-ftr-logo" src="assets/img/ujjwalsinghsignature.png" />
                    </div>
                    <div class="SCORE-certifcate-input-label">SIGNATURE</div>
                </div>
            </div>
        </div>
        <img src="assets/img/certificate-score-new.png" alt="Score Certificate" />
    </div>
</div>